import React, { useState, useEffect } from "react";
import { capitalizeWords } from "../ConfiguracionListado/helper/CapitalizeWords";
import { FormatMoney } from '../../../Helpers/FormatNumber'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import SaveIcon from '@mui/icons-material/Save';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import { ModalImagenes } from "./ModalImagenes";
import CollectionsIcon from '@mui/icons-material/Collections';
import { ModalCarruselImagenes } from "./ModalCarruselImagenes";

export const TablaConfImagenContainer = ({ datos, ObtenerListado, filtrar, setFiltrar, setKeyFiltrado }) => {
    const [openModal, setOpenModal] = useState(false);
    const [openModalCarrusel, setOpenModalCarrusel] = useState(false);
    const [imagenes, setImagenes] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    // console.log(guardar)

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpen = async (rowData) => {
        setSelectedRow(rowData);
        setLoader({ ...loader, mostrar: true });

        try {
            const result = await request.get(`ImagenesProductoAliado/BuscarImagenes?idinventario=${rowData.idinventario}`);

            if (result && result.length > 0) {
                setImagenes(result);
                setOpenModal(true);
                setLoader({ ...loader, mostrar: false });
            } else {
                setImagenes([]);
                setOpenModal(true);
                setLoader({ ...loader, mostrar: false });
            }
        } catch (error) {
            console.error(error);
            setOpenModal(true);
        }
    };

    const handleClose = () => setOpenModal(false);

    const handleOpenCarrusel = async (rowData, imagen) => {
        // console.log(imagen)
        if (imagen === "N") {
            return
        }
        else {
            setSelectedRow(rowData);
            setLoader({ ...loader, mostrar: true });

            try {
                const result = await request.get(`ImagenesProductoAliado/BuscarImagenes?idinventario=${rowData.idinventario}`);

                if (result && result.length > 0) {
                    setImagenes(result);
                    setOpenModalCarrusel(true);
                    setLoader({ ...loader, mostrar: false });
                } else {
                    Swal.fire("Imagenes", "Este tractor no cuenta con imagenes", "warning");
                    setLoader({ ...loader, mostrar: false });
                }
            } catch (error) {
                console.error(error);
            }
        }

    };

    const handleCloseCarrusel = () => setOpenModalCarrusel(false);

    // console.log(imagenes)

    const onEstatus = (estatus) => {
        if (estatus === "L") {
            return "info-estatus-circulo circulo-verde"
        }
        else if (estatus === "A") {
            return "info-estatus-circulo circulo-amarillo"
        }
        else if (estatus === "V") {
            return "info-estatus-circulo circulo-rojo"
        }
    }


    const onFiltrar = (filtro) => {
        setFiltrar(!filtrar)
        setKeyFiltrado(filtro)
    }

    const getMonthName = (dateString) => {
        const currentDate = new Date();  // Obtiene la fecha actual
        const currentMonth = currentDate.getMonth();  // Obtiene el número de mes (0 - 11)

        if (!dateString) return '';

        const [day, month, year] = dateString.split('/');
        const monthNames = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];

        // Concatenamos el nombre del mes actual y el mes del dateString
        return monthNames[currentMonth] + ' - ' + monthNames[parseInt(month) - 1];
    };


    return (
        <div className="paliado-listado-precios-container">
            <LoaderScreen loader={loader} />
            <div className="paliado-listado-precios-imagenes-container-table scroll-4">
                <table cellSpacing={0} cellPadding={0}>
                    <thead>
                        <tr>
                            <th>
                            </th>
                            <th>
                            </th>
                            <th></th>
                            <th>
                                MARCA
                            </th>
                            <th>
                                <div>MODELO</div>
                            </th>
                            <th>
                                <div>N. E.</div>
                            </th>
                            <th>
                                <div>DESCRIPCION</div>
                            </th>
                            <th>
                                <div className="listado-precios-modificar-todo-button-container">
                                    IMAGENES
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {datos.map((datos, index) => (
                            <tr>
                                <td className="celda-circulo">{index + 1}</td>
                                <td className="celda-circulo">
                                    <div className={onEstatus(datos.estatus)}></div>
                                </td>
                                <td className="celda-img">
                                    <div className={datos.tiene_imagen === "S" ? "img" : "img-sin-color"} onClick={() => handleOpenCarrusel(datos, datos.tiene_imagen)}>
                                        <CollectionsIcon />
                                    </div>
                                </td>
                                <td className="celda-modelo">{datos.marca}</td>
                                <td className="celda-marca">{datos.modelo}</td>
                                <td className="celda-marca ta-center">{datos.ne}</td>
                                <td className='celda-modelo'>{datos.modelo_descripcion}</td>
                                <td className='celda-button'>
                                    <div className="imagenes-button"
                                        onClick={() => handleOpen(datos)} style={{ cursor: "pointer" }}
                                    >
                                        <AddPhotoAlternateIcon />
                                        Imágenes
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {/* )  */}
            </div>

            <div className="listado-precios-footer-container">
                <div className="listado-precios-info-container">
                    <div className="info-estatus">

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("L")}>
                            <div className="info-estatus-circulo circulo-verde"></div>
                            Listo para la venta
                        </div>

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("A")}>
                            <div className="info-estatus-circulo circulo-amarillo"></div>
                            Acondicionando
                        </div>

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("T")}>
                            <div className="info-estatus-circulo circulo-dividido"></div>
                            Todos
                        </div>
                    </div>
                </div>

            </div>
            <ModalImagenes open={openModal} handleClose={handleClose} datos={selectedRow} imagenesBD={imagenes} />
            <ModalCarruselImagenes open={openModalCarrusel} handleClose={handleCloseCarrusel} datos={selectedRow} imagenesBD={imagenes} />
        </div>
    )
}
